import { Language } from '../types'
import { Locale } from '~/code/components/Translation/types/Locale'

export const DEFAULT_LANGUAGE: Language = 'en'
export const DEFAULT_LOCALE: Locale = 'en_GB'
